import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { ExecutionReportResponse } from "../types";
import axiosClient from "../utils/axiosClient";

export const useGetExecutionsReport = () => {
  return useQuery<any, AxiosError<any>, ExecutionReportResponse>(
    ["report", "execution"],
    () =>
      axiosClient
        .get<ExecutionReportResponse>(`/reports/executionsReport`)
        .then(({ data }) => data),
    { staleTime: Infinity }
  );
};
